import * as React from "react";

import "./select-template.scss";

import {cs}           from "@Common/react/chain-services";
import {GlobalKeys}   from "@Common/react/global-keys-react";
import {UseState}     from "@Common/react/use-state";
import { Responsive } from "@Common/ui-components/responsive";

import {Layout} from "../../../../../../layout/layout";

import {ListMode}   from "./list-mode/list-mode";
import {SingleMode} from "./single-mode/single-mode";

export const SelectTemplate = ({title, templateBacks = null, selected, next,}) => cs(
    ["view", (_, next) => UseState({
        /* possible states:
            {mode: null, integer lastSelected} (main screen)
            {mode: "list", integer lastSelected} (grid view)
            {mode: "single", integer lastSelected, integer id, boolean fromList} (carousel view) */
            
        initValue: {mode: null},
        next,
    })],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ({view, responsive}) => !view.value.mode ? (
        next({
            list: () => view.onChange({mode: "list", lastSelected: selected.value}),
            single: (id) => view.onChange({mode: "single", id: id, lastSelected: selected.value}),
            getLastSelected: () => view.value.lastSelected,
        })
    ) : cs(
        ({}, next) => <Layout className="select-template-2ja">{next()}</Layout>,
        () => view.value.mode === "list" ? <>
            <div className="header">
                <GlobalKeys {...{
                    keyCombo: "Escape",
                    onKeyDown: () => view.onChange({mode: null, lastSelected: selected.value}),
                }} />

                <a className="back" onClick={() => view.onChange({mode: null, lastSelected: selected.value})} xd-qa-type="link" xd-qa-name="Back to Product Options">
                    <i className="fa fa-chevron-left"/>
                    {responsive.lt("mobile") ? "Back" : "Back to Product Options"}
                </a>

                <div className="title">
                    {title}
                </div>
            </div>

            <div className="main">
                {ListMode({
                    templateBacks: templateBacks, 
                    onZoom: (id) => {view.onChange({mode: "single", id: id, fromList: true})},
                    onButton: (id) => {
                        selected.onChange(id);
                        view.onChange({mode: null, lastSelected: id});
                    },
                    onImage: (id) => {
                        selected.onChange(id);
                        responsive.lt("mobile") ? view.onChange({mode: null, lastSelected: id}) : view.onChange({...view.value, lastSelected: id});
                    },
                    selected: selected,
                })}
            </div>
        </> : <>
            <div className="header">

                <GlobalKeys {...{
                    keyCombo: "Escape",
                    onKeyDown: () => view.onChange({mode: "list"}),
                }} />

                <a 
                    className="back" 
                    onClick={() => view.value.fromList ? view.onChange({mode: "list", lastSelected: selected.value}) : view.onChange({mode: null, lastSelected: selected.value})}
                    xd-qa-type="link" 
                    xd-qa-name={view.value.fromList ? "Back to Grid View" : "Back to Product Options"}
                >
                    <i className="fa fa-chevron-left"/>
                    {view.value.fromList ? "Back to Grid View" : "Back to Product Options"}
                </a>
                <div className="right">
                    <div className="title">
                        {templateBacks[view.value.id]?.name}
                    </div>

                </div>
            </div>

            <div className="main">
                {SingleMode({
                    templateBacks,
                    currentlySelected: selected.value,
                    currentlyViewing: view.value.id,
                    onSelect: id => {
                        selected.onChange(id);
                        view.onChange({mode: null, lastSelected: id});
                    },
                    onChangeView: id => view.onChange({...view.value, id: id}),
                })}
            </div>
        </>
    ),
);